import { render, staticRenderFns } from "./Arbitrations.vue?vue&type=template&id=45174001"
import script from "./Arbitrations.vue?vue&type=script&lang=js"
export * from "./Arbitrations.vue?vue&type=script&lang=js"
import style0 from "./Arbitrations.vue?vue&type=style&index=0&id=45174001&prod&lang=scss&module=true"
import style1 from "./Arbitrations.vue?vue&type=style&index=1&id=45174001&prod&lang=scss"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports